import gql from 'graphql-tag';

const dias_festivosTableQuery = gql`
    query dias_festivos($whereCondition:DiasFestivosWhereWhereConditions, $numberItems: Int!, $numberPage: Int!, $fieldOrder: String!, $Order: SortOrder!) {
        dias_festivos(where:$whereCondition, first: $numberItems, page: $numberPage, activo: true, orderBy:[{field: $fieldOrder, order: $Order}]) {
            data {
                id,
                nombre,
                descripcion,
                cliente_id,
                empresa_id,
                fecha,
                cliente {
                    nombre
                },
                empresa{
                    nombre
                },
                sucursal{
                    nombre
                }
                departamentos{
                    id,nombre
                }
            }
            paginatorInfo {
                count
                currentPage
                firstItem
                lastItem
                hasMorePages
                lastPage
                perPage
                total
            }
        }
    }
`

const queries = { dias_festivosTableQuery };

export default queries;
